import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "./productViewTemplate.css";
import ProductQuoteForm from "./productQuoteForm";

const ProductViewTemplate = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/products/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setProduct(data);
      })
      .catch((err) => console.error(err));
  }, [id]);

  if (!product) return (
    <div className="view-loading">
      <div className="spinner"></div>
      <h2>Preparing System Data...</h2>
    </div>
  );

  const featuresList = Array.isArray(product.features) ? product.features : [];
  const specificationsList = Array.isArray(product.specifications) ? product.specifications : [];

  return (
    <main className="pv-wrapper">
      {/* 1. HERO SECTION */}
      <section className="pv-hero">
        <div className="pv-container">
          <div className="pv-hero-grid">
            
            {/* Left: Product Media */}
            <div className="pv-media">
              <div className="pv-badge-certified">✓ DGCA Certified</div>
              <img
                src={product.image ? `${API_BASE_URL}${product.image}` : "/placeholder.png"}
                alt={product.name}
                className="main-product-img"
              />
            </div>

            {/* Right: Essential Info */}
            <div className="pv-essence">
              <span className="pv-category-label">{product.category || 'Professional Fleet'}</span>
              <h1 className="pv-title">{product.name}</h1>
              <p className="pv-lead">{product.description || 'Enterprise-grade UAV solution engineered for high-precision autonomous operations.'}</p>
              
              <div className="pv-price-anchor">
                <span className="label">Investment Starts At</span>
                <span className="value">₹{product.price?.toLocaleString()}</span>
              </div>

              <div className="pv-action-row">
                <button className="pv-btn-primary" onClick={() => setShowForm(true)}>
                  Request Technical Quote
                </button>
                <div className="pv-stock-status">
                  <span className="dot"></span> {product.stock > 0 ? `${product.stock} Units Deployable` : 'Limited Availability'}
                </div>
              </div>

              <div className="pv-dashboard">
                <div className="dash-item">
                  <span className="dash-icon">⚙️</span>
                  <div className="dash-txt">
                    <small>System</small>
                    <strong>High-End</strong>
                  </div>
                </div>
                <div className="dash-item">
                  <span className="dash-icon">🛰️</span>
                  <div className="dash-txt">
                    <small>Precision</small>
                    <strong>GPS Pro</strong>
                  </div>
                </div>
                <div className="dash-item">
                  <span className="dash-icon">🔋</span>
                  <div className="dash-txt">
                    <small>Endurance</small>
                    <strong>25min+</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. TECHNICAL DATASHEET SECTION (Gray) */}
      <section className="pv-datasheet">
        <div className="pv-container">
          <div className="datasheet-grid">
            
            {/* Left: Capability Highlights */}
            <div className="datasheet-column">
              <h2 className="datasheet-title">Key Capabilities</h2>
              <div className="capabilities-list">
                {featuresList.length > 0 ? (
                  featuresList.map((item, i) => (
                    <div className="capability-item" key={i}>
                      <span className="cap-marker">•</span>
                      <p className="cap-text">{item}</p>
                    </div>
                  ))
                ) : (
                  <p className="fallback-txt">Advanced flight control and telemetry integration.</p>
                )}
              </div>
            </div>

            {/* Right: Technical Manifest */}
            <div className="datasheet-column">
              <h2 className="datasheet-title">Technical Specifications</h2>
              <div className="specs-manifest">
                {specificationsList.length > 0 ? (
                  specificationsList.map((item, i) => {
                    const [key, value] = item.includes(':') ? item.split(':') : [null, item];
                    return (
                      <div className="manifest-row" key={i}>
                        <div className="manifest-key">{key ? key.trim() : 'Operational'}</div>
                        <div className="manifest-val">{value ? value.trim() : item}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="manifest-row">
                    <div className="manifest-key">Hardware</div>
                    <div className="manifest-val">Industrial Grade</div>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 3. FINAL CALL TO ACTION */}
      <section className="pv-bottom-cta">
        <div className="pv-container">
          <div className="cta-banner">
            <h3>Ready for Deployment?</h3>
            <p>Our technical team is ready to assist with fleet integration and training services.</p>
            <button className="pv-btn-white" onClick={() => setShowForm(true)}>Get Enterprise Quote</button>
          </div>
        </div>
      </section>

      {/* Quote Form Popup */}
      {showForm && (
        <ProductQuoteForm
          product={product}
          onClose={() => setShowForm(false)}
        />
      )}
    </main>
  );
};

export default ProductViewTemplate;
